import { Grid2, Typography } from "@mui/material";
import { Fragment } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";

import {
    GqlDashboardClientUserClientList,
    GqlDashboardFieldworkerLatestFeedback,
    GqlDashboardFieldworkerNextDays,
    GqlDashboardFieldworkerNextShift,
    GqlDashboardProjectUserProjectList,
} from "~/__generated__";
import useAppDashboardGetComponents, { AppDashboardComponent } from "~/modules/app/api/useAppDashboardGetComponents";
import DashboardFieldworkerOnboarding from "~/modules/app/components/DashboardComponents/DashboardFieldworkerOnboarding";
import GaiaPageLayoutColumn from "~/modules/app/components/GaiaPageLayoutColumn";
import ErrorScreen from "~/modules/app/screens/ErrorScreen";
import LoadingScreen from "~/modules/app/screens/LoadingScreen";
import useCurrentUser from "~/modules/auth/hooks/useCurrentUser";

import DashboardClientUserClientList from "../components/DashboardComponents/DashboardClientUserClientList";
import DashboardFieldworkerAvailabilityRequired from "../components/DashboardComponents/DashboardFieldworkerAvailabilityRequired";
import DashboardFieldworkerLatestFeedback from "../components/DashboardComponents/DashboardFieldworkerLatestFeedback";
import DashboardFieldworkerNextDays from "../components/DashboardComponents/DashboardFieldworkerNextDays";
import DashboardFieldworkerNextShift from "../components/DashboardComponents/DashboardFieldworkerNextShift";
import DashboardProjectUserProjectList from "../components/DashboardComponents/DashboardProjectUserProjectList";

function renderComponent(component: AppDashboardComponent) {
    switch (component.__typename) {
        case "GqlDashboardFieldworkerOnboarding":
            return <DashboardFieldworkerOnboarding />;
        case "GqlDashboardFieldworkerAvailabilityRequired":
            return <DashboardFieldworkerAvailabilityRequired />;
        case "GqlDashboardFieldworkerNextDays":
            return <DashboardFieldworkerNextDays component={component as GqlDashboardFieldworkerNextDays} />;
        case "GqlDashboardFieldworkerNextShift":
            return <DashboardFieldworkerNextShift component={component as GqlDashboardFieldworkerNextShift} />;
        case "GqlDashboardFieldworkerLatestFeedback":
            return <DashboardFieldworkerLatestFeedback component={component as GqlDashboardFieldworkerLatestFeedback} />;
        case "GqlDashboardClientUserClientList":
            return <DashboardClientUserClientList component={component as GqlDashboardClientUserClientList} />;
        case "GqlDashboardProjectUserProjectList":
            return <DashboardProjectUserProjectList component={component as GqlDashboardProjectUserProjectList} />;
    }
}

export default function MainDashboardScreen() {
    const { t } = useTranslation("app");

    const user = useCurrentUser();

    const { data, loading, error } = useAppDashboardGetComponents();
    if (loading) return <LoadingScreen />;
    if (error) return <ErrorScreen error={error} />;

    return (
        <GaiaPageLayoutColumn maxWidth="lg">
            <Typography variant="h1">
                {t("dashboardComponents.mainDashboardScreen.title", {
                    firstName: user?.firstName,
                })}
            </Typography>
            <Grid2 container spacing={2} justifyContent="center">
                {data.map(component => (
                    <Fragment key={component.id}>{renderComponent(component)}</Fragment>
                ))}
            </Grid2>
        </GaiaPageLayoutColumn>
    );
}
